import React, {Component} from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import {Control, Errors, Fieldset} from "react-redux-form";
import {formatMoney} from "accounting-js";
import {toInt} from "../../parsers";
import {isRequired, minValue, required} from "../../field_validations";
import {confirmAlert} from "react-confirm-alert";
import ConagoModal from "./project_conago_modal_widget";
import MunsModal from "./project_muns_modal_widget";
import ActorsModal from "./project_actors_modal_widget";
import ActivityWidget from "./activities";

const propTypes = {
	goals: PropTypes.array.isRequired
}

class ModIProject extends Component {
	render() {
		let {goals, allgoals, resources, revision, directories, municipalities} = this.props;
		return <Fieldset model="project.registry.data.project_goals">

			<MunsModal
				show={this.state.modalShow}
				active={this.state.modalShow}
				closeModal={this._toggleModal}
				selectedMuns={this.state.selectedGoal !== undefined ? goals[this.state.selectedGoal].agencies : undefined}
				selectedGoal={this.state.selectedGoal}
				modality={1}
				muns={municipalities}
				add={this.props.add}
				remove={this.props.remove}
				conclusion={this.state.canEdit}
			/>

			<ConagoModal
				active={this.state.conagoShow}
				closeModal={this._toggleConagoModal}
				selectedConago={this.state.selectedGoal !== undefined ? goals[this.state.selectedGoal].conago_clauses : undefined}
				selectedGoal={this.state.selectedGoal}
				conagoClauses={directories.conago}
				fetching={directories.isFetching}
				add={this.props.add}
				remove={this.props.remove}
				conclusion={this.state.canEdit}
			/>

			<ActorsModal
				fetching={directories.isFetching}
				active={this.state.actorsShow}
				closeModal={this._toggleActorsModal}
				selectedActors={this.state.selectedGoal !== undefined ? goals[this.state.selectedGoal].actors : undefined}
				selectedGoal={this.state.selectedGoal}
				actors={directories.actors}
				add={this.props.add}
				remove={this.props.remove}
				conclusion={this.state.canEdit}
			/>

			{!_.isEmpty(goals) &&
			<table className="table is-fullwidth project-goal-table">
				<thead>
				<tr>
					<th>Código</th>
					<th>Nombre</th>
					<th>Monto</th>
					<th className="has-text-right">Acciones</th>
				</tr>
				</thead>
				{_.map(goals, (goal, k) => {
					let goalRevision = revision ? _.find(revision, {id: goal.proigualdad_goal_id}) : undefined
					let goalTrashDisabled = this._permissionField() && goalRevision ? (Boolean(goal.mandatory) || (_.find(goalRevision.activities, {allow_edit: 'true'}) === undefined ? true : false) || (goalRevision.allow_edit === 'true' ? false : true)) : (this._permissionField() ? Boolean(goal.mandatory) : true);
					let goalDisabled = this._permissionField() && goalRevision ? (goalRevision.allow_edit === 'true' ? false : true) : (this._permissionField() ? false : true);
					return (
						<tbody key={k}>
						<tr>
							<td rowSpan={3} className={`goal-cell${goalRevision ? ' is-' + goalRevision.status : ''}`}>
								<strong>{goal.code}</strong></td>
							<td>
								{goal.name}
								{(goal.mandatory === 1) &&
								<small className="help is-primary is-small">Esta meta es obligatoria</small>}
								<br/>
								{(goalRevision && goalRevision.comment) &&
								<small className={`tag is-${goalRevision.status}`}>{goalRevision.comment}</small>}
							</td>
							<td className="amount">{formatMoney(_.toNumber(goal.total))}</td>
							<td className="has-text-right">
								<button type="button" onClick={() => this._removeGoal(goal, k, this.props.projectTotal)}
								        disabled={goalTrashDisabled} className="button is-danger">
									<i className="fa fa-trash"/>
								</button>
							</td>
						</tr>
						<tr>
							<td colSpan={3}>
								<div className="field is-grouped">
									<div className="control">
										<div
											className={`select is-small${goalRevision && goalRevision.status ? ' is-' + goalRevision.status : ' is-dark'}`}>
											<Control.select
												model={`[${k}].resource_concept_id`}
												id={`goal-rc-${goal.proigualdad_goal_id}`}
												parser={toInt}
												errors={{required}}
												validateOn="change"
												disabled={goalDisabled}>
												<option value={0} defaultValue>--- Conceptos de gasto ---</option>
												{_.map(resources.list, (res, t) => {
													return <option value={res.id} key={t}>{res.name}</option>;
												})}
											</Control.select>
										</div>
										<Errors
											model={`[${k}].resource_concept_id`}
											wrapper={(props) => <small
												className="help has-text-danger">{props.children}</small>}
											messages={{required: 'Debes indicar el concepto de gasto.'}}
										/>
									</div>
								</div>
							</td>
						</tr>
						<tr>
							<td colSpan={3}>
								<div className="field is-grouped">
									<div className="control">
										<div className="message is-small is-primary">
											<div className="message-body">
												<div className="field">
													<div className="control">
														<label htmlFor={`.[${k}]is_continuing`}
														       className="checkbox">
															<Control.checkbox
																model={`.[${k}]is_continuing`}
																id={`.[${k}]is_continuing`}
																className="checkbox"
																isToggle={true}
																disabled={goalDisabled}
															/>
															<span
																style={{whiteSpace: 'normal'}}> Meta de continuidad</span>
														</label>
													</div>
												</div>
											</div>
										</div>
									</div>

									<div className="control">
										<div className="tags has-addons">
											<span style={{cursor: 'pointer'}} className="tag is-medium is-light"
											      onClick={() => this._openConagoModal(k, goal.conago_clauses, goalDisabled)}>Metas CONAGO</span>
											<span
												className="tag is-medium is-white">{_.size(goal.conago_clauses)}</span>
										</div>
										{_.size(goal.conago_clauses) <= 0 ?
											<span
												className="help is-danger">Debes elegir al menos una meta CONAGO</span> : ''}
									</div>
									<div className="control">
										<div className="tags has-addons">
													<span style={{cursor: 'pointer'}} className="tag is-medium is-light"
													      onClick={() => this._openActorsModal(k, goal.actors, goalDisabled)}>Actores estratégicos</span>
											<span
												className="tag is-medium is-white">{_.size(goal.actors)}</span>
										</div>
									</div>

									{goal.geographic_area === 'Municipios' &&
									<div className="control">
										<div className="tags has-addons">
													<span style={{cursor: 'pointer'}}
													      className="tag is-medium is-light"
													      onClick={() => this._openMunModal(k, goal, goalDisabled)}>Seleccionar municipios</span>
											<span className="tag is-medium is-white">{_.size(goal.agencies)}</span>
										</div>
										{_.size(goal.agencies) === 0 &&
										<small className="help is-danger is-small">
											Seleccionar municipios participantes
										</small>}
									</div>}

									<div className="control">
										<div className="select is-dark is-small">
											<Control.select
												model={`[${k}].geographic_area`}
												id={`goal-ga-${goal.proigualdad_goal_id}`}
												ref={`goal-ga-${goal.proigualdad_goal_id}`}
												errors={{isRequired}} validateOn="change"
												disabled={goalDisabled}
											>
												<option value="">--- Area geográfica ---</option>
												<option value="Estatal">Estatal</option>
												<option value="Municipios">Municipios</option>
												<option value="Todos los municipios">Todos los municipios
												</option>
											</Control.select>
										</div>
										<Errors
											model={`[${k}].geographic_area`}
											wrapper={(props) => <small
												className="help has-text-danger">{props.children}</small>}
											messages={{isRequired: 'Seleccionar area geográfica'}}
										/>
									</div>
								</div>
							</td>
						</tr>
						<tr>
							<td colSpan={4}>
								<ActivityWidget
									goal={goal}
									disabled={goalDisabled}
									goals={goals}
									add={this.props.add}
									change={this.props.change}
									activities={_.find(allgoals, {id: goal.proigualdad_goal_id})}
								/>
							</td>
						</tr>
						{!_.isEmpty(goal.project_goal_activities) ?
							<tr>
								<td colSpan={4}>
									<table className="table is-fullwidth project-activity-table">
										<thead>
										<tr>
											<th className="has-text-centered">ID</th>
											<th>Actividad</th>
											<th className="has-text-centered">Cantidad</th>
											<th className="has-text-right">Total</th>
											<th className="has-text-right">Medio de verificación</th>
											<th className="has-text-right">Acciones</th>
										</tr>
										</thead>
										<tbody>
										{_.map(goal.project_goal_activities, (act, j) => {
											let actRevision = goalRevision ? _.find(goalRevision.activities, {id: act.proigualdad_activity_id}) : undefined;
											let activityTrashDisabled = this._permissionField() && actRevision ? (Boolean(act.mandatory) || (actRevision.allow_edit === 'true' ? false : true)) : (this._permissionField() ? Boolean(act.mandatory) : true);
											let activityDisabled = this._permissionField() && actRevision ? (actRevision.allow_edit === 'true' ? false : true) : (this._permissionField() ? false : true);
											return [
												<tr key={j}>
													<td rowSpan={actRevision && actRevision.comment ? 2 : 1}
													    className={actRevision && actRevision.status ? `has-text-centered is-${actRevision.status}` : 'has-text-centered'}>{act.proigualdad_activity_id}</td>
													<td>
														{act.name}{act.mandatory === 1 &&
													<small className="help is-primary">
														Esta actividad es obligatoria
													</small>}
													</td>
													<td className="has-text-centered">
														{act.allow_edit ?
															<div>
																<Control.text
																	model={`project.registry.data.project_goals[${k}].project_goal_activities[${j}].quantity`}
																	type="number" min={1} step={1}
																	className="input"
																	errors={{required, minValue: minValue(1)}}
																	validateOn="change"
																	changeAction={(model, value) => this._editActivity(k, j, value, act.amount, goal)}
																	style={{width: '40%'}}/>
																<Errors
																	model={`project.registry.data.project_goals[${k}].project_goal_activities[${j}].quantity`}
																	show="touched"
																	wrapper={(props) => <small
																		className="help has-text-danger">{props.children}</small>}
																	messages={{
																		required: 'Cantidad Obligatoria',
																		minValue: 'Minimo no admitido.'
																	}}/>
															</div>
															: act.quantity}
													</td>
													<td className="has-text-right amount">{formatMoney(_.toNumber(act.total))}</td>
													<td className="has-text-right">{act.verification_media ? act.verification_media.name : ''}</td>
													<td className="has-text-right">
														<div className="field is-grouped">
															{act.allow_edit ? '' :
																<div className="control">
																	<button
																		className="button is-info"
																		type="button"
																		onClick={() => this.props.change(`project.registry.data.project_goals[${k}].project_goal_activities[${j}]`, {
																			...act,
																			allow_edit: true
																		})}
																		disabled={activityDisabled}
																	>
																		<i className="fa fa-edit"/>
																	</button>
																</div>}
															{act.allow_edit &&
															<div className="control">
																<button className="button is-success"
																        type="button"
																        onClick={() => this.props.change(`project.registry.data.project_goals[${k}].project_goal_activities[${j}]`, {
																	        ...act,
																	        allow_edit: false
																        })} disabled={activityDisabled}>
																	<i className="fa fa-check"/>
																</button>
															</div>}
															<div className="control">
																<button
																	type="button"
																	className="button is-danger"
																	onClick={() => this._removeActivity(act, j, goal, k, this.props.projectTotal)}
																	disabled={activityTrashDisabled}>
																	<i className="fa fa-trash"/>
																</button>
															</div>
														</div>
													</td>
												</tr>,
												(actRevision && actRevision.comment) &&
												<tr key={`act-${j}-comment`}>
													<td colSpan={5}>
														<small>Comentarios: <span
															className={`tag ${actRevision && actRevision.status ? 'is-' + actRevision.status : ''}`}>{actRevision.comment}</span>
														</small>
													</td>
												</tr>
											]
										})}
										</tbody>
									</table>
								</td>
							</tr>
							: <tr>
								<td colSpan={4} className="has-text-info">
									<p>Debes agregar por lo menos una actividad</p>
								</td>
							</tr>}
						</tbody>
					)
				})}
			</table>}
		</Fieldset>
	}

	constructor(props) {
		super(props);
		this.state = {
			modalShow: false,
			conagoShow: false,
			actorsShow: false,
			goalMuns: [],
			goalConago: [],
			goalActors: [],
			selectedGoal: undefined,
			canEdit: false
		}
		this._toggleModal = this._toggleModal.bind(this);
		this._toggleConagoModal = this._toggleConagoModal.bind(this);
		this._toggleActorsModal = this._toggleActorsModal.bind(this);
	}

	_toggleModal() {
		return this.setState({
			modalShow: !this.state.modalShow
		});
	}

	_toggleConagoModal() {
		return this.setState({
			conagoShow: !this.state.conagoShow
		});
	}

	_toggleActorsModal() {
		return this.setState({
			actorsShow: !this.state.actorsShow
		});
	}

	_removeActivity(activity, activityIndex, goal, goalIndex, total) {
		if (activity.mandatory === 0) {
			this.props.remove(`project.registry.data.project_goals[${goalIndex}].project_goal_activities`, activityIndex);
			this.props.change(`project.registry.data.project_goals[${goalIndex}].total`, goal.total - activity.total);
			this.props.change(`project.registry.data.amounts`, total - activity.total);
		} else {
			alert('Esta actividad es obligatoria y no se puede eliminar');
		}
	}

	_removeGoal(goal, goalIndex, total) {
		if (goal.mandatory === 0) {
			confirmAlert({
				title: '¿Esta seguro?',
				message: 'Al eliminarse la meta, se eliminará toda información y actividades vinculadas.',
				confirmLabel: 'Eliminar',
				cancelLabel: 'Cancelar',
				onConfirm: () => {
					this.props.change('project.registry.data.amounts', (total - goal.total));
					this.props.remove('project.registry.data.project_goals', goalIndex);
				}
			});
		}
	}

	_openMunModal(goalIndex, goal, disable) {
		let {state, entities} = this.props;
		let entity = _.find(entities, {short: state});
		this.props.fetchMunicipalities(entity.id);
		return this.setState({
			modalShow: true,
			goalMuns: goal.agencies,
			selectedGoal: goalIndex,
			canEdit: disable
		});
	}

	_openConagoModal(index, conagoList, disable) {
		return this.setState({
			conagoShow: true,
			goalConago: conagoList,
			selectedGoal: index,
			canEdit: disable
		})
	}

	_openActorsModal(index, actorsList, disable) {
		return this.setState({
			actorsShow: true,
			goalActors: actorsList,
			selectedGoal: index,
			canEdit: disable
		})
	}

	_editActivity(goalIndex, activityIndex, quantity, amount, goal) {
		if (quantity > 0) {
			this.props.change(`project.registry.data.project_goals[${goalIndex}].total`, goal.total + (quantity * amount));
			this.props.change(`project.registry.data.project_goals[${goalIndex}].project_goal_activities[${activityIndex}].total`, _.toNumber(quantity * amount));
			this.props.change(`project.registry.data.project_goals[${goalIndex}].project_goal_activities[${activityIndex}].quantity`, _.toInteger(quantity));
		}
	}

	_permissionField() {
		return this.props.editable;
	}
}

ModIProject.propTypes = propTypes;

export default ModIProject;


// WEBPACK FOOTER //
// ./src/elements/project/widgets/project_mod-i_goals_list_widget.jsx